import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { IContentfulBackgroundColour } from "../../../../types/IContentfulBackgroundColour";

const BgImage3D: React.FC<{variant?: IContentfulBackgroundColour, side?: "left" | "right"}> = (
  { variant, side },
) => {
  switch (variant) {
    case "light-green": {
      return side === "right" ? (
        <StaticImage
          src="../../../../static/images3D/remortgage-3D-right.png"
          alt="info-icon"
          placeholder="none"
          quality={100}
        />
      ) : (
        <StaticImage
          src="../../../../static/images3D/remortgage-3D-left.png"
          alt="info-icon"
          placeholder="none"
          quality={100}
        />
      );
    }
    case "light-purple": {
      return side === "right" ? (
        <StaticImage
          src="../../../../static/images3D/insurance-3D-right.png"
          alt="info-icon"
          placeholder="none"
          quality={100}
        />
      ) : (
        <StaticImage
          src="../../../../static/images3D/insurance-3D-left.png"
          alt="info-icon"
          placeholder="none"
          quality={100}
        />
      );
    }
    case "light-yellow":
    default: {
      return side === "right" ? (
        <StaticImage
          src="../../../../static/images3D/purchase-3D-right.png"
          alt="info-icon"
          placeholder="none"
          quality={100}
        />
      ) : (
        <StaticImage
          src="../../../../static/images3D/purchase-3D-left.png"
          alt="info-icon"
          placeholder="none"
          quality={100}
        />
      );
    }
  }
};

export default BgImage3D;
